import { render, staticRenderFns } from "./dashbroadCasesTable.vue?vue&type=template&id=4e6605b3&lang=pug"
import script from "./dashbroadCasesTable.vue?vue&type=script&lang=js"
export * from "./dashbroadCasesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports